import { NAME } from './constants';

export const ADD_SEGMENT_MODAL_OPEN_STATUS = `${NAME}/ADD_SEGMENT_MODAL_OPEN_STATUS`;
export const ADD_SEGMENT_MODAL_EDITION_MODE = `${NAME}/ADD_SEGMENT_MODAL_EDITION_MODE`;

export const CHANGE_MODULE_STATUS = `${NAME}/CHANGE_MODULE_STATUS`;
export const CHANGE_MODULE_STATUS_SUCCESS = `${NAME}/CHANGE_MODULE_STATUS_SUCCESS`;
export const CHANGE_MODULE_STATUS_FAILURE = `${NAME}/CHANGE_MODULE_STATUS_FAILURE`;

export const CHECK_SEGMENT = `${NAME}/CHECK_SEGMENT`;
export const CHECK_SEGMENT_FAILURE = `${NAME}/CHECK_SEGMENT_FAILURE`;
export const CHECK_SEGMENT_SUCCESS = `${NAME}/CHECK_SEGMENT_SUCCESS`;

export const DELETE_SEGMENT = `${NAME}/DELETE_SEGMENT`;
export const DELETE_SEGMENT_FAILURE = `${NAME}/DELETE_SEGMENT_FAILURE`;
export const DELETE_SEGMENT_SUCCESS = `${NAME}/DELETE_SEGMENT_SUCCESS`;

export const EDIT_SEGMENT = `${NAME}/EDIT_SEGMENT`;
export const EDIT_SEGMENT_FAILURE = `${NAME}/EDIT_SEGMENT_FAILURE`;
export const EDIT_SEGMENT_SUCCESS = `${NAME}/EDIT_SEGMENT_SUCCESS`;

export const ENABLED_EDITION = `${NAME}/ENABLED_EDITION`;
export const ENABLED_EDITION_FAILURE = `${NAME}/ENABLED_EDITION_FAILURE`;
export const ENABLED_EDITION_SUCCESS = `${NAME}/ENABLED_EDITION_SUCCESS`;

export const FETCH_OFFER_INFO_PATERN = `${NAME}/FETCH_OFFER_INFO_PATERN`;
export const FETCH_OFFER_INFO_PATERN_FAILURE = `${NAME}/FETCH_OFFER_INFO_PATERN_FAILURE`;
export const FETCH_OFFER_INFO_PATERN_SUCCESS = `${NAME}/FETCH_OFFER_INFO_PATERN_SUCCESS`;

export const FETCH_OFFER_PANELS = `${NAME}/FETCH_OFFER_PANELS`;
export const FETCH_OFFER_PANELS_FAILURE = `${NAME}/FETCH_OFFER_PANELS_FAILURE`;
export const FETCH_OFFER_PANELS_SUCCESS = `${NAME}/FETCH_OFFER_PANELS_SUCCESS`;

export const FETCH_PARENT_FIELD_SEGMENT = `${NAME}/FETCH_SEGMENTS`;
export const FETCH_PARENT_FIELD_SEGMENT_FAILURE = `${NAME}/FETCH_PARENT_FIELD_SEGMENT_FAILURE`;
export const FETCH_PARENT_FIELD_SEGMENT_SUCCESS = `${NAME}/FETCH_PARENT_FIELD_SEGMENT_SUCCESS`;

export const FETCH_PRESET = `${NAME}/FETCH_PRESET`;
export const FETCH_PRESET_FAILURE = `${NAME}/FETCH_PRESET_FAILURE`;
export const FETCH_PRESET_SUCCESS = `${NAME}/FETCH_PRESET_SUCCESS`;

export const GENERATE_PROPOSAL = `${NAME}/GENERATE_PROPOSAL`;
export const GENERATE_PROPOSAL_FAILURE = `${NAME}/GENERATE_PROPOSAL_FAILURE`;
export const GENERATE_PROPOSAL_SUCCESS = `${NAME}/GENERATE_PROPOSAL_SUCCESS`;

export const INITIALIZE_VALUES = `${NAME}/INITIALIZE_VALUES`;

export const INITIALIZE_SHADER_SETTINGS_VALUES = `${NAME}/INITIALIZE_SHADER_SETTINGS_VALUES`;

export const RESET_FORM = `${NAME}/RESET_FORM`;

export const RESET_VALUES = `${NAME}/RESET_VALUES`;

export const SAVE_ALL_SEGMENTS = `${NAME}/SAVE_ALL_SEGMENTS`;
export const SAVE_ALL_SEGMENTS_FAILURE = `${NAME}/SAVE_ALL_SEGMENTS_FAILURE`;
export const SAVE_ALL_SEGMENTS_SUCCESS = `${NAME}/SAVE_ALL_SEGMENTS_SUCCESS`;

export const SAVE_IMAGE = `${NAME}/SAVE_IMAGE`;
export const SAVE_IMAGE_FAILURE = `${NAME}/SAVE_IMAGE_FAILURE`;
export const SAVE_IMAGE_SUCCESS = `${NAME}/SAVE_IMAGE_SUCCESS`;

export const SAVE_SEGMENT = `${NAME}/SAVE_SEGMENT`;
export const SAVE_SEGMENT_FAILURE = `${NAME}/SAVE_SEGMENT_FAILURE`;
export const SAVE_SEGMENT_SUCCESS = `${NAME}/SAVE_SEGMENT_SUCCESS`;

export const SAVE_SHADER_SETTINGS = `${NAME}/SAVE_SHADER_SETTINGS`;
export const SAVE_SHADER_SETTINGS_FAILURE = `${NAME}/SAVE_SHADER_SETTINGS_FAILURE`;
export const SAVE_SHADER_SETTINGS_SUCCESS = `${NAME}/SAVE_SHADER_SETTINGS_SUCCESS`;

export const SAVE_POSITION = `${NAME}/SAVE_POSITION`;
export const SAVE_POSITION_FAILURE = `${NAME}/SAVE_POSITION_FAILURE`;
export const SAVE_POSITION_SUCCESS = `${NAME}/SAVE_POSITION_SUCCESS`;

export const SELECT_SEGMENT = `${NAME}/SELECT_SEGMENT`;
export const SETUP_SIMULATION = `${NAME}/SETUP_SIMULATION`;
export const SET_COPY_BUFFER = `${NAME}/SET_COPY_BUFFER`;
export const SET_DRAWING_MODE = `${NAME}/SET_DRAWING_MODE`;
export const SET_DRAWING_TYPE = `${NAME}/SET_DRAWING_TYPE`;
export const SET_IS_DISABLED_EDITION = `${NAME}/SET_IS_DISABLED_EDITION`;
export const SET_IS_DISABLING_MODULES = `${NAME}/SET_IS_DISABLING_MODULES`;
export const SET_NEW_SEGMENT_CONFIG = `${NAME}/SET_NEW_SEGMENT_CONFIG`;
export const SET_SELECTED_ITEMS = `${NAME}/SET_SELECTED_ITEMS`;
export const SET_VIEW_LAYER_STATUS = `${NAME}/SET_VIEW_LAYER_STATUS`;

export const UPDATE_SEGMENTS = `${NAME}/UPDATE_SEGMENTS`;
export const UPDATE_SOLAR_MODULES_DESIGN_NUMBER = `${NAME}/UPDATE_SOLAR_MODULES_DESIGN_NUMBER`;
